import type { FeatureDefinition } from './features';

export default [
  {
    name: 'viewDepotLandingPage',
    isMainView: true,
    isRootLevel: true,
    route: 'subcontractorLanding',
    action: 'r:depot-landing-page'
  },
  {
    name: 'viewLiveStatus',
    action: 'r:tour',
    isMainView: true,
    isRootLevel: true,
    route: 'subcontractorLiveStatus'
  },
  {
    name: 'liveStatusMapEnabled',
    action: 'r:live-status-map',
    needs: 'r:tour'
  },
  {
    name: 'tourDetailView',
    action: 'r:tour-details',
    needs: 'r:tour'
  },
  {
    name: 'tourDetailViewDevice',
    action: 'r:tour-device',
    needs: 'r:tour-details'
  },
  {
    name: 'tourDetailViewDriverLocation',
    action: 'r:tour-details-driver-location',
    needs: 'r:tour-details'
  },
  {
    name: 'viewLiveIssues',
    action: 'r:live-issues',
    isMainView: true,
    isRootLevel: true,
    route: 'subcontractorLiveStatus'
  },
  {
    name: 'updateLiveIssues',
    action: 'u:live-issues',
    auto: ['r:live-issues']
  },
  {
    name: 'viewUsageAnalysis',
    action: 'r:tour-activity',
    isMainView: true,
    isRootLevel: true,
    route: 'subcontractorDailyActivities'
  },
  {
    name: 'viewUsageAnalysisFull',
    action: 'r:tour-activity-full',
    needs: 'r:tour-activity'
  },
  {
    name: 'tourDrivenHistory',
    action: 'r:tour-location-history',
    needs: 'r:tour-activity'
  },
  {
    name: 'readTourActivity',
    action: 'r:rtt',
    needs: 'r:tour-activity'
  },
  {
    name: 'viewTourRecommendations',
    action: 'r:tour-activity-recommendations',
    needs: 'r:rtt'
  },
  {
    name: 'readHealthStatus',
    action: 'r:health-status',
    isRootLevel: true,
    standAloneFeature: true
  },
  {
    name: 'readSmartInsights',
    action: 'r:smart-insights',
    isRootLevel: true,
    standAloneFeature: true
  },
  {
    name: 'viewTourPerformance',
    action: 'r:tour-perf',
    isMainView: true,
    isRootLevel: true,
    route: 'subcontractorTourPerformance'
  },
  {
    name: 'viewDrivers',
    action: 'r:driver',
    isMainView: true,
    isRootLevel: true,
    route: 'subcontractorAppAccounts'
  },
  {
    name: 'createDriver',
    action: 'c:driver',
    needs: 'r:driver'
  },
  {
    name: 'updateDriver',
    action: 'u:driver',
    needs: 'r:driver'
  },
  {
    name: 'deleteDriver',
    action: 'd:driver',
    needs: 'r:driver'
  },
  {
    name: 'lastMeterEnabled',
    action: 'r:last-meter-locations',
    isRootLevel: true
  },
  {
    name: 'readBetterPlanner',
    action: 'r:better-planner',
    isMainView: false,
    isRootLevel: true
  }
] as const satisfies readonly FeatureDefinition[];
